module.exports = __webpack_public_path__ + "img/res4.9068063f.png";